import React, { useState } from 'react'
import {IoMdRemove,IoIosAdd} from "react-icons/io";
import img1 from "../asstes/images/Group 36.png"
import img2 from "../asstes/images/Group 37.png"
import img3 from "../asstes/images/Group 38.png"
import img4 from "../asstes/images/Group 362.png"
import img5 from "../asstes/images/Group 372.png";
import img6 from "../asstes/images/Group 382.png"
import contact from "../asstes/images/content.png"
import Default from "../asstes/images/Default.png"
import { useNavigate } from 'react-router-dom';
import ProfileNav from '../components/navber/ProfileNav';

const Permanent = () => {
    const navigate = useNavigate()
    const [state, setstate] = useState(1);
    const [count,setCount] = useState(2)

    const rmoveCount = ()=>{
        if(count !== 1){
            setCount((pre)=> --pre)
        }
    }

    const addCount = ()=>{
        setCount((pre)=> ++pre )
    }

    const submit = ()=>{
        navigate("/profile")
    }

  return (
    <>
        <ProfileNav/>
        <div className='md:pt-[130px] pt-[70px]'>
        <div className='flex items-start max-w-[1340px] md:pl-[20px] gap-5  ml-auto flex-col-reverse md:flex-row justify-between'>
            <div className='flex-[4]'>
               <div className='md:px-0 px-5 '>
                    <h2 className='text-[24px] font-bold mb-6'>Elige un método de pago</h2>
                    <div className='flex items-center md:gap-[40px] gap-[20px] flex-wrap'>
                        <div onClick={()=>setstate(1)} className={`prement_box md:w-[192px] w-[109px] md:h-[162px] h-[90px] p-4 flex flex-col items-center gap-2 cursor-pointer justify-center ${state === 1 ? "bg-[#4285F4] text-white" :"bg-[#DCE5F5]"}`}>
                            
                            {state === 1 ? (<img src={img2} alt="" className='md:w-auto md:h-auto w-[30px] h-[25px]' />) : (<img src={img5} alt=""  className='md:w-auto md:h-auto w-[30px] h-[25px]'/>)}
                            <h2 className='md:text-[24px]  text-[14px] font-bold'>Tarjeta de crédito</h2>
                        </div>
                        <div onClick={()=>setstate(2)} className={`prement_box md:w-[192px] w-[109px] md:h-[162px] h-[90px] p-4 flex flex-col items-center gap-2 cursor-pointer justify-center ${state === 2 ? "bg-[#4285F4] text-white" :"bg-[#DCE5F5]"}`}>
                            {state === 2 ? (<img src={img4} alt="" className='md:w-auto md:h-auto w-[30px] h-[25px]'/>) : (<img src={img1} alt="" className='md:w-auto md:h-auto w-[30px] h-[25px]'/>)}
                            <h2 className='md:text-[24px]  text-[14px] font-bold'>Efectivo</h2>
                        </div>
                        <div onClick={()=>setstate(3)} className={`prement_box md:w-[192px] w-[109px] md:h-[162px] h-[90px] p-4 flex flex-col items-center gap-2 cursor-pointer justify-center ${state === 3 ? "bg-[#4285F4] text-white" :"bg-[#DCE5F5]"}`}>
                            {state ===3 ? (<img src={img6} alt="" className='md:w-auto md:h-auto w-[30px] h-[25px]'/>):(<img src={img3} alt="" className='md:w-auto md:h-auto w-[30px] h-[25px]'/>)}
                            <h2 className='md:text-[24px]  text-[14px] font-bold'>Transferencia SPEI</h2>
                        </div>
                    </div>
               </div>

                <div className='mt-[40px] xl:max-w-[730px] md:px-0 px-5 '>
                    {state === 1 && (
                        <div>
                            <h2 className='md:text-[24px] md:mb-4 mb-2 text-[14px] font-bold'>Tarjeta de crédito</h2>
                            <div>
                                <div className='flex py-4 lg:items-center items-start justify-between flex-col lg:flex-row'>
                                    <div>
                                        <h3 className='md:text-[20px] text-[16px] font-medium'>Número de tarjeta</h3>
                                        <p className='md:text-[16px] text-[14px] font-normal'>Enter the 16-digit card number on the card</p>
                                    </div>
                                    <div className='flex items-center'>
                                        <div className=' relative'>
                                            <input type="text" className='border-2 lg:w-[336px] w-full py-2 px-9 rounded-md border-[#CFCFCF] outline-none'/>
                                            <img className=' absolute top-2 left-2' src={contact} alt="" />
                                        </div>
                                        <div className='w-[30px]'>
                                            <img src={Default} alt="" className='ml-2' />
                                        </div>
                                    </div>
                                </div>
                                <div className='flex py-4 lg:items-center items-start justify-between flex-col lg:flex-row'>
                                    <div>
                                        <h3 className='md:text-[20px] text-[16px] font-medium'>Nombre</h3>
                                        <p className='md:text-[16px] text-[14px]  font-normal'>Enter the name on the card</p>
                                    </div>
                                    <div className='flex items-center'>
                                        <input type="text" className='border-2 lg:w-[336px] w-full py-2 px-9 rounded-md border-[#CFCFCF] outline-none'/>
                                        <div className='w-[30px]'>
                                            
                                        </div>
                                    </div>
                                </div>
                                <div className='flex pr-5 py-4 lg:items-center items-start justify-between flex-col lg:flex-row'>
                                    <div>
                                        <h3 className='md:text-[20px] text-[16px] font-medium'>Fecha de expiración</h3>
                                        <p className='md:text-[16px] text-[14px]  font-normal'>Enter the expration date of the card</p>
                                    </div>
                                    <div className='flex items-center gap-5'>
                                        <div className='flex items-center md:gap-3 gap-1'>
                                            <input type="text" className='md:w-[60px] w-[40px] border-2 py-2 px-2 rounded-md border-[#CFCFCF] outline-none'/>
                                            <h2 className='text-[30px]'>/</h2>
                                            <input type="text" className='md:w-[60px] w-[40px]  border-2 py-2 px-2 rounded-md border-[#CFCFCF] outline-none'/>
                                        </div>
                                        <div className='flex items-center gap-2'>
                                            <div>
                                            <h3 className='md:text-[20px] text-[16px] font-medium'>CVV</h3>
                                            <p className='md:text-[16px] text-[14px]  font-normal'>Security code</p>
                                            </div>
                                            <input type="text" className='border-2 w-[60px]  py-2 px-2 rounded-md border-[#CFCFCF] outline-none'/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='flex items-center md:justify-end justify-start'>
                                <button onClick={()=>submit()} className='py-4 px-5 bg-[#4285F4] text-white text-[14px] font-medium rounded-md md:text-[24px]'>Continuar</button>
                            </div>
                        </div>
                    )}

                    {state === 2 && (
                        <div>
                            <div className='ml-[20px]'>
                                <div className='flex items-center gap-5 md:py-6 py-2'>
                                    <input type="checkbox" id='chke' className='chakbox' />
                                    <label className='md:text-[24px] lg:w-full text-[14px] font-normal' htmlFor="chke">7 eleven</label>
                                </div>
                                <div className='flex items-center gap-5 md:py-6 py-2'>
                                    <input type="checkbox" id='chke' className='chakbox' />
                                    <label className='md:text-[24px] lg:w-full text-[14px] font-normal' htmlFor="chke">Oxxo</label>
                                </div>
                                <div className='flex items-center gap-5 md:py-6 py-2'>
                                    <input type="checkbox" id='chke' className='chakbox' />
                                    <label className='md:text-[24px] lg:w-full text-[14px] font-normal' htmlFor="chke">Farmacias Guadalajara</label>
                                </div>
                            </div>
                            <button onClick={()=>submit()} className='py-4 px-5 bg-[#4285F4] text-white text-[14px] mt-10 font-medium rounded-md md:text-[24px]'>Descargar talón de pago</button>
                        </div>
                    )}

                    {
                        state === 3 && (
                            <div>
                                <button onClick={()=>submit()} className='py-4 px-5 bg-[#4285F4] text-white text-[14px] mt-10 font-medium rounded-md md:text-[24px]'>Descargar talón de pago</button>
                            </div>
                        )
                    }

                </div>

            </div>
            <div className='flex-[2] w-full h-[650px] bg-[#4285F4] p-5 relative'>
                <div className='p-5 md:h-auto h-[250px]'>
                    <p className='md:text-[24px] md:mb-14 text-white text-[20px] font-bold'>Resumen de contratación</p>
                    <p className='md:text-[24px] md:mb-8 text-white text-[16px] font-normal'>Análisis y regularización fiscal</p>
                    <div className='flex items-center gap-5'>
                        <p className='md:text-[24px] text-white text-[15px] font-normal'>Meses no declarados</p>
                        <div className=' text-white border-2 border-gray-300 flex items-center gap-2 py-1 px-2'>
                            <button onClick={()=>rmoveCount()}  className='text-white'><IoMdRemove/></button>
                            <p>{count}</p>
                            <button onClick={()=>addCount()}  className='text-white'><IoIosAdd className=' text-white'/></button>
                        </div>
                    </div>
                    <p className='md:text-[24px] md:mt-8 text-white text-[20px] font-normal'>$1000.00 x {count}</p>
                </div>
                <div className=' absolute w-full px-5 bottom-[20px] left-0'>
                    <div className='w-full h-[2px] bg-white'> </div>
                    <div className=' text-[24px] flex items-center justify-between text-white py-3 px-5'>
                        <h3 className=' font-bold'>Total</h3>
                        <p>${1000.00 * count} MXN</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </>
  )
}

export default Permanent